import { onPrivacyChange } from "./consent";
import { OptionalAnalytics } from "./optional-analytics";
import { reportAudioFailure, type AudioFailureReason } from "./audio-response";

const POSTHOG_TOKEN = "phc_Cth9fFjjcJTCgrj7sLYW7JHPefcWtZAt7a2ynHkfmxwm";
const isLocalPreview = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

function clearAnalyticsStorage(): void {
  const ownsKey = (key: string) => key.startsWith(`ph_${POSTHOG_TOKEN}`) || key === `__ph_opt_in_out_${POSTHOG_TOKEN}`;
  for (const storageName of ["localStorage", "sessionStorage"] as const) {
    try {
      const storage = window[storageName];
      Object.keys(storage).filter(ownsKey).forEach((key) => storage.removeItem(key));
    } catch { /* Storage can be blocked by browser privacy settings. */ }
  }
  try {
    const domains = ["", window.location.hostname, `.${window.location.hostname}`, ".tinyaudiotools.com"];
    document.cookie.split(";").map((cookie) => cookie.trim().split("=")[0]!).filter(ownsKey).forEach((name) => {
      for (const domain of domains) {
        document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax${domain ? `; domain=${domain}` : ""}`;
      }
    });
  } catch { /* Some browser settings block cookie access as well as storage. */ }
}

const analytics = new OptionalAnalytics(
  () => import("./posthog-client").then(({ createAnalyticsClient }) => createAnalyticsClient()),
  clearAnalyticsStorage,
);
onPrivacyChange((preferences) => {
  void analytics.setConsent(isLocalPreview ? { analytics: false, replay: false } : preferences);
});

export function captureProcessingFailure(
  reason: AudioFailureReason,
  properties: Record<string, unknown>,
): void {
  reportAudioFailure(analytics, reason, properties);
}

export function showDownloadSurvey(): void { analytics.showDownloadSurvey(); }
export default analytics;
